import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface AdditionalInfoProps {
  productDetails: any;
}

const AdditionalInfo: React.FC<AdditionalInfoProps> = ({ productDetails }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const tips = productDetails?.metadata.tip || [];

  const initialTips = tips.slice(0, 3);
  const extraTips = tips.slice(3);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    tips.length > 0 && (
      <div className="w-full flex flex-row items-start justify-between">
        <div className="w-full flex flex-col items-start justify-start">
          <div className="flex flex-col items-start space-y-4 pl-1">
            {/* Render the first three tips */}
            {initialTips.map((tip: string, index: number) => (
              <div key={index} className="flex flex-row items-center space-x-4">
                <i className="fa-regular fa-md fa-lightbulb text-neutral-700"></i>
                <p className="text-sm text-neutral-600 font-[325] leading-[23px]">
                  {tip}
                </p>
              </div>
            ))}

            {/* Animate the extra tips */}
            <AnimatePresence initial={false}>
              {isExpanded && (
                <motion.div
                  className="flex flex-col items-start space-y-4 overflow-hidden"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.2, ease: "easeInOut" }}
                >
                  {extraTips.map((tip: string, index: number) => (
                    <div
                      key={index + 3}
                      className="flex flex-row items-center space-x-3"
                    >
                      <i className="fa-regular fa-md fa-lightbulb text-neutral-700"></i>
                      <p className="text-sm text-neutral-600 font-[325] leading-[23px]">
                        {tip}
                      </p>
                    </div>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* Show "More" or "Less" button if there are more than 3 tips */}
          {tips.length > 3 && (
            <button
              onClick={handleToggle}
              className="mt-4 text-neutral-500 text-sm font-extralight flex flex-col items-center focus:outline-none mx-auto"
            >
              {isExpanded ? (
                <>
                  <i className="far fa-angle-up"></i>
                  <p>Less</p>
                </>
              ) : (
                <>
                  <p>More</p>
                  <i className="far fa-angle-down"></i>
                </>
              )}
            </button>
          )}
        </div>
      </div>
    )
  );
};

export default AdditionalInfo;
